import { alpha, Box, Stack, Typography, useTheme } from "@mui/material";
import ImageBackground from "../../../../utility/component/ImageBackground";
import { sectionIds } from "../../const/course";
import type { CourseDetailsPageData } from "../../hook/useCourseDetailsPageData";
import { getSectionTitle } from "../../util/course";
import { getCourseMediaFrameSx } from "./const/surface";
import RevealSection from "./RevealSection";
import SectionShell from "./SectionShell";

export type CohortCarouselSectionProps = Readonly<{
  data: CourseDetailsPageData;
}>;

export default function CohortCarouselSection({ data }: CohortCarouselSectionProps) {
  const theme = useTheme();

  return (
    <RevealSection>
      <SectionShell id="cohorts" title={getSectionTitle(data.pageMap, sectionIds.cohorts)}>
        <Box sx={{ overflowX: "auto", scrollSnapType: "x mandatory", WebkitOverflowScrolling: "touch", pb: 2.5 }}>
          <Stack direction="row" spacing={3} sx={{ width: "max-content", pr: 1 }}>
            {data.cohortCarouselItems.map((item) => (
              <Stack
                key={item.id}
                spacing={2}
                sx={{
                  scrollSnapAlign: "start",
                  width: { xs: 280, sm: 320 },
                }}
              >
                <Box
                  sx={{
                    position: "relative",
                    overflow: "hidden",
                    aspectRatio: "16 / 9",
                    ...getCourseMediaFrameSx(theme),
                  }}
                >
                  <ImageBackground image={item.image} center="center" sx={{ width: 1, height: 1 }} />
                </Box>
                <Stack spacing={0.75}>
                  <Typography variant="h5" color="primary.contrastText">
                    {item.title}
                  </Typography>
                  <Typography variant="body1" sx={{ color: alpha(theme.palette.primary.contrastText, 0.72) }}>
                    {item.description}
                  </Typography>
                </Stack>
              </Stack>
            ))}
          </Stack>
        </Box>
      </SectionShell>
    </RevealSection>
  );
}

